<template>
  <div>
    <div class="main">
      <div class="titlefont">
        <div class="titleAnimation">
          <div class="title">{{ strength.title }}</div>
          <div class="desc">
            {{ strength.about }}
          </div>
        </div>
      </div>
      <div class="tLeft">
        <div class="conMain boxShow">
          <div class="con">
            <div class="coninfo">
              <div class="tit">{{ teachersInfo.name }}</div>
              <div class="subTit">{{ teachersInfo.quarters }}</div>
              <div class="des">{{ teachersInfo.details }}</div>
            </div>
          </div>
        </div>
        <div class="conPhoto">
          <div class="boxShow">
            <div class="con">
              <div class="swiper">
                <div class="label"></div>
                <div class="swiperItems">
                  <div class="rowBut rowFootBut">
                    <div class="swiper-button-prev">
                      <div class="swLeftBut"></div>
                    </div>
                    <div class="swiper-button-next">
                      <div class="swRightBut"></div>
                    </div>
                  </div>
                  <swiper :options="swiperOption">
                    <swiper-slide
                      id="num"
                      class="items"
                      v-for="(item, index) in teachersList"
                      :key="index"
                    >
                      <div
                        :class="{
                          swPointLine: true,
                          act: teachersIndex == index,
                        }"
                        @click="teachShowHandle(index)"
                      ></div>
                      <div
                        :class="{
                          teachItem: true,
                          act: teachersIndex == index,
                        }"
                        @click="teachShowHandle(index)"
                      >
                        <div class="line"></div>
                        <div class="activeImg">
                          <img
                            v-if="item.headerImage[0].url != 'undefined'"
                            :src="item.headerImage[0].url"
                            width="131"
                            alt=""
                            style="cursor: "
                            @click="teachShowHandle(index)"
                          />
                        </div>
                      </div>
                    </swiper-slide>
                  </swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tRight">
        <div class="imgInfo">
          <img :src="teachersInfo.headerImage[0].url" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    teachersList: {
      type: Array,
      default: () => [],
    },
    strength: {
      type: Object,
      default: () => {},
    },
    teachersInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      biggerImgPreview: false,
      teachersIndex: 0,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerGroup: 2,
        allowTouchMove: false,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "swiper-button-disabled-class",
        },
      },
    };
  },
  methods: {
    // 教师信息展示切换
    teachShowHandle(index) {
      this.teachersIndex = index;
      this.$emit("teachShowHandle", index);
    },
  },
};
</script>

